export const initialStateConstants = {
  searchString: '',
  filterActive: 0,
  filterMenuStatus: false,
  overviewFilterPills: [],
  structure: [],
  structureFilterId: '',
  structureFilterDataArray: [],
  structureFilterComplex: [],
  structureFilterReadable: {},
  locationFilterId: [],
  locationFilterDataArray: [],
  locationFilterReadable: {},
  location: [],
  degreeFilterId: [],
  degreeFilterDataArray: [],
  degreeFilterReadable: {},
  degree: [],
  niveauFilterId: [],
  niveauFilterDataArray: [],
  niveauFilterReadable: {},
  niveau: [],
  eventTypeFilterId: [],
  eventTypeFilterDataArray: [],
  eventTypeFilterReadable: {},
  eventType: [],
  days: [],
  daysFilterId: [],
  daysFilterDataArray: [],
  time: [],
  timeFilterId: [],
  timeFilterDataArray: [],
  special: [],
  specialFilterId: [],
  specialFilterDataArray: []
};

export default initialStateConstants;
